export const PRODUCT_DISCLAIMER = 'productDisclaimer';
export const DISCLAIMER = 'disclaimer';
